import { userUploadsApi } from "../../api/user-uploads-api";
import {
    ACTION_GET_USER_UPLOADS_DOCUMENTS_TYPES,
    MUTATION_SET_USER_UPLOADS_DOCUMENTS_TYPES,
    ACTION_SAVE_USER_UPLOADS_DOCUMENT,
    ACTION_DELETE_USER_UPLOADS_DOCUMENT,

} from "./types";
import { state  } from "./index";

export default  {
    [ACTION_GET_USER_UPLOADS_DOCUMENTS_TYPES]: async ({ commit }) => {
        if (state.documentsTypes.length > 0) {
            // If documents types are already loaded, no need to fetch again
            return state.documentsTypes;
        }

        try {
            const response = await userUploadsApi.getDocumentsTypes()
            commit(MUTATION_SET_USER_UPLOADS_DOCUMENTS_TYPES, response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching user uploads documents types:", error);
            return null;
        }
    },
    [ACTION_SAVE_USER_UPLOADS_DOCUMENT]: async ({ commit }, payload) => {
        const response = await userUploadsApi.saveUserUploadsDocument(payload);
        return response.data;
    },
    [ACTION_DELETE_USER_UPLOADS_DOCUMENT]: async ({ commit }, payload) => {
        const response = await userUploadsApi.deleteUserUploadsDocument(payload);
        return response.data;
    }
}